import ErrorAlert from 'common/components/alert/ErrorAlert';
import Page from 'common/components/page/Page';
import { PageTemplates } from 'common/components/page/PageTemplates';
import { isActionCompleteSuccess } from 'common/services/api/isActionCompleteSuccess';
import { ActionCompleteResponse } from 'common/types/ApiResponse';
import React from 'react';
import { Button, Card } from 'react-bootstrap';

interface ISendConfirmationPresenter {
  loading: boolean;
  error: string | null;
  data: ActionCompleteResponse | null;
  email: string | null;
  onTryAgainClick: () => void;
}

const SendConfirmationPresenter = (props: ISendConfirmationPresenter) => {
  let content;
  if (props.loading) {
    content = (
      <p>
        Sending confirmation email to {props.email}... This may take a few
        moments.
      </p>
    );
  } else if (props.error) {
    content = (
      <ErrorAlert>{`Uh oh! We could not send your email: ${props.error}`}</ErrorAlert>
    );
  } else if (props.data && isActionCompleteSuccess(props.data)) {
    content = (
      <>
        <p>A confirmation email has been sent to {props.email}.</p>
        <p>
          {"Didn't receive an email?"}{' '}
          <Button
            variant='link'
            className='p-0 vertical-align-baseline'
            onClick={props.onTryAgainClick}
          >
            Click here
          </Button>{' '}
          to send another email.
        </p>
      </>
    );
  }

  return (
    <Page template={PageTemplates.centered}>
      <Card>
        <Card.Body>
          <h3 className='mb-3'>Confirm Email</h3>
          {content}
        </Card.Body>
      </Card>
    </Page>
  );
};

export default SendConfirmationPresenter;
